export default {
  timeout: 10000, // 请求超时时间
  /**
   * @description 请求基地址
   */
  baseURL: '/eshop',
  /**
   * @description mock接口基地址
   */
  mockBaseURL: '/mock',
  /**
   * @description cookie相关键值
   */
  cookie: {
    TOKEN: 'Eshop-Access-Token', // Eshop-Backend-Access-Token
    NEED_VCODE: 'eshop_need_verification_code',
    USER_AGENT: 'eshop_user_agent',
    OPENID: 'openid',
    REDRIECT_URL: 'redriect_url'
  },
  /**
   * @description 请求需要携带的自定义Header
   */
  headers: {
    TOKEN: 'Eshop-Access-Token',
    USER_AGENT: 'Eshop-User-Agent'
  },
  plaltform: {
    WX: 1,
    QQ: 2,
    SINA: 3
  },
  banner: {
    home: {
      CAROUSEL: 11,
      BRAND: 12
    }
  },
  swiper: { // 轮播映射关系
    SLIDE: 'slide',
    FADE: 'fade',
    CUBE: 'cube',
    COVERFLOW: 'coverflow',
    FLIP: 'flip'
  },
  api: { // 公共接口
    area: '/eshop/pub/area/china/selectByParentCode'
  },
  localStorage: {
    searchHistory: 'searchHistory'
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js